export default "__VITE_ASSET__B$SHCCFk__"